import { render, staticRenderFns } from "./BurglauerInfopoint.vue?vue&type=template&id=010dd4c8&scoped=true&"
import script from "./BurglauerInfopoint.vue?vue&type=script&lang=js&"
export * from "./BurglauerInfopoint.vue?vue&type=script&lang=js&"
import style0 from "./BurglauerInfopoint.vue?vue&type=style&index=0&id=010dd4c8&scoped=true&lang=css&"
import style1 from "./BurglauerInfopoint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010dd4c8",
  null
  
)

export default component.exports